<template>
<svg width="100pt" height="100pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
<path :fill="fill" d="m22.055 22.055c1.625-1.6289 4.2656-1.6289 5.8906 0l22.055 22.055 22.055-22.055c1.625-1.6289 4.2656-1.6289 5.8906 0 1.6289 1.625 1.6289 4.2656 0 5.8906l-22.055 22.055 22.055 22.055c1.6289 1.625 1.6289 4.2656 0 5.8906-1.625 1.6289-4.2656 1.6289-5.8906 0l-22.055-22.055-22.055 22.055c-1.625 1.6289-4.2656 1.6289-5.8906 0-1.6289-1.625-1.6289-4.2656 0-5.8906l22.055-22.055-22.055-22.055c-1.6289-1.625-1.6289-4.2656 0-5.8906z"/>
</svg>
</template>

<script setup>
	const props = defineProps({
	  fill: {
	    type: String,
	    default: 'currentColor'
	  }
	})
</script>